import React from "react";
import RouteList from "Routes/private/list";
import { Menu } from "antd";
import { Link, Route, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useStoreState } from "easy-peasy";

const { SubMenu } = Menu;

export default function Navigation({ current, ...props }) {
  const { abilities } = useStoreState((store) => store.auth);

  const history = useHistory();
  const root = RouteList.find((f) => f.root);
  const renderMenuItem = (item, path) => {
    if (
      !(
        abilities.can("All", item.authSubject) ||
        abilities.can("Menu", item.authSubject)
      )
    )
      return;
    const Icon = item.icon ? (
      <FontAwesomeIcon
        icon={[item.icon.library, item.icon.name]}
        style={{ marginRight: 8 }}
      />
    ) : null;

    if (
      item.children?.length > 0 &&
      item.children?.some((s) => s.navigation) &&
      !item.layout
    ) {
      if (item.root) {
        return item.children
          .filter((f) => {
            return f.navigation;
          })
          .map((subItem, subItemIdx) =>
            renderMenuItem(subItem, path + item.path)
          );
      } else {
        return (
          <SubMenu
            key={item.name}
            onTitleClick={() => {
              if (item.clickable) history.push(path + item.path);
            }}
            title={
              <span>
                {Icon}
                {item.name}
              </span>
            }
          >
            {item.children
              .filter((f) => {
                return f.navigation;
              })
              .map((subItem, subItemIdx) =>
                renderMenuItem(subItem, path + item.path)
              )}
          </SubMenu>
        );
      }
    } else {
      if (item.navigation)
        return (
          <Menu.Item key={item.name}>
            <Link to={path + item.path}>
              {Icon}
              {item.name}
            </Link>
          </Menu.Item>
        );
      else return null;
    }
  };

  return (
    <Menu
      theme="dark"
      mode="horizontal"
      defaultSelectedKeys={[(current && current.key) || "Ana Sayfa"]}
    >
      <Menu.Item key={root.name}>
        <Link to={root.path}>
          <FontAwesomeIcon
            icon={[root.icon.library, root.icon.name]}
            style={{ marginRight: 8 }}
          />
          {root.name}
        </Link>
      </Menu.Item>
      {RouteList.map((item, menuIdx) => renderMenuItem(item, ""))}
    </Menu>
  );
}
